import request from './adminRequest'

export const lectureApi = {
  listLecture (params) {
    return request.get('/lectures', { params: params })
  },
  getLecture (id) {
    return request.get('/lectures/' + id)
  },
  saveLecture (data) {
    return request.post('/lectures', data)
  },
  updateLecture (id, data) {
    return request.put('/lectures/' + id, data)
  },
  updateLectureSortNum (id, data) {
    return request.put('/lectures/' + id + '/sortNum', data)
  },
  deleteLecture (id) {
    return request.delete('/lectures/' + id)
  },

}
export default lectureApi
